// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__2_IzE","label":"Section_label__3aLiK","contentWrap":"Section_contentWrap__279vw","footer":"Section_footer__2tus4","footerInner":"Section_footerInner__2bNaE"};